import { render } from "./ProductAdmin.vue?vue&type=template&id=7162ab8e"
import script from "./ProductAdmin.vue?vue&type=script&lang=js"
export * from "./ProductAdmin.vue?vue&type=script&lang=js"

import "./ProductAdmin.vue?vue&type=style&index=0&id=7162ab8e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__